// core
import { Component, EventEmitter, Input, Output } from "@angular/core";

// services

// API
import {
    OperationCommentClient,
    OperationComment,
    CreateOperationCommentRequest,
    UpdateOperationCommentRequest,
} from "../../WebApiClient";

// models & components
import { ComponentBase } from "../../models/ComponentBase";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";

// #region Component
@Component({
    selector: "app-operation-logbook",
    standalone: false,
    templateUrl: "./operation-logbook.component.html",
    styleUrls: ["./operation-logbook.component.scss"],
    providers: [OperationCommentClient],
})
export class TerminalOperationLogbookComponent extends ComponentBase {
    public comments: OperationComment[] = [];
    public newComment = '';
    public hasUnreadComments = false;
    @Input()
    public operationId!: string;
    public editingCommentId: string | null = null;
    public editedText = '';
    @Output()
    public closed = new EventEmitter<void>();
    @Input()
    public embedded = false;

    // #region Construct
    public constructor(
        private readonly operationCommentClient: OperationCommentClient,
        public readonly activeModal: NgbActiveModal
    ) {
        super();
    }

    // #region onInit
    ngOnInit(): void {
        this.loadComments();
        this.checkUnreadComments();
    };

    public async loadComments(): Promise<void> {
        if (!this.operationId) {
            return;
        }

        try {

            const comments =
                await this.operationCommentClient
                    .getComments(this.operationId)
                    .toPromise();

            this.comments = comments ?? [];

        }
        catch (error) {

            console.error(error);

        }
    }

    public async postComment(): Promise<void> {
        if (!this.newComment.trim()) {
            return;
        }

        try {

            await this.operationCommentClient
                .createComment(
                    this.operationId,
                    new CreateOperationCommentRequest({
                        comment: this.newComment
                    })
                )
                .toPromise();

            this.newComment = '';

            await this.loadComments();

        }
        catch (error) {

            console.error(error);

        }
    }

    public async markCommentsAsRead(): Promise<void> {
        if (!this.operationId) {
            return;
        }

        try {

            await this.operationCommentClient
                .markCommentsAsRead(this.operationId)
                .toPromise();

            this.hasUnreadComments = false;

        }
        catch (error) {

            console.error(error);

        }
    }

    public async checkUnreadComments(): Promise<void> {
        if (!this.operationId) {
            return;
        }

        try {

            const result =
                await this.operationCommentClient
                    .hasUnreadComments(this.operationId)
                    .toPromise();

            this.hasUnreadComments = result ?? false;

        }
        catch (error) {

            console.error(error);

        }
    }

    public startEdit(comment: OperationComment): void {

        this.editingCommentId = comment.id ?? null;

        this.editedText = comment.comment ?? "";
    }

    public cancelEdit(): void {

        this.editingCommentId = null;

        this.editedText = '';
    }

    public async saveEdit(
        comment: OperationComment
    ): Promise<void> {

        await this.operationCommentClient
            .updateComment(
                this.operationId,
                comment.id ?? "",
                new UpdateOperationCommentRequest({
                    comment: this.editedText
                })
            )
            .toPromise();

        this.editingCommentId = null;

        await this.loadComments();
    }

    public static open(
        modalService: NgbModal,
        operationId: string
    ) {
        const modal = modalService.open(
            TerminalOperationLogbookComponent,
            {
                backdrop: false,
                keyboard: false,
                scrollable: false,
            });

        const instance =
            modal.componentInstance as TerminalOperationLogbookComponent;

        instance.operationId = operationId;
        instance.embedded = false;

        return modal;
    }

    public close(): void {

        if (this.embedded) {
            this.closed.emit();
            return;
        }

        this.activeModal.dismiss();
    }
}
